import React from 'react';
import Routing from './Routing/Routing';
import { ToastContainer } from 'react-toastify';

const App = () => {
  return (
    <>
      <ToastContainer />
      <Routing />
    </>
  )
}

export default App